import { render, staticRenderFns } from "./InvestmentStatistics.vue?vue&type=template&id=f876eb08&scoped=true"
import script from "./InvestmentStatistics.vue?vue&type=script&lang=js"
export * from "./InvestmentStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f876eb08",
  null
  
)

export default component.exports